export default __webpack_public_path__ + "static/media/business-discussion.463bf6da.webp";